
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { ArgsTable, Canvas, Meta, Story } from '@storybook/addon-docs';
import { availableSamples, highlightDemo } from './demo/demo.ts';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Vendor/Highlight" parameters={{
      docs: {
        transformSource: src => src
      },
      layout: 'fullscreen'
    }} argTypes={{
      language: {
        options: availableSamples,
        type: 'string',
        control: {
          type: 'select'
        }
      }
    }} mdxType="Meta" />
    <h1>{`Highlight`}</h1>
    <p>{`Our CSS includes a `}<a parentName="p" {...{
        "href": "https://highlightjs.org/"
      }}>{`Highlight.js`}</a>{` theme for syntax highlighting.`}</p>
    <p>{`For performance, it's strongly recommended to apply syntax highlighting on the server:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://highlightjs.readthedocs.io/en/latest/readme.html#node-js-on-the-server"
        }}>{`Highlight.js Basic Usage: Node.js on the Server`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/scrivo/highlight.php"
        }}>{`Highlight.php`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/?path=/docs/vendor-syntax-highlighting-code-block--basic"
        }}>{`Syntax-Highlighting Code Block`}</a></li>
    </ul>
    <Canvas mdxType="Canvas">
  <Story name="Theme" args={{
        language: 'html'
      }} mdxType="Story">
    {highlightDemo.bind({})}
  </Story>
    </Canvas>
    <ArgsTable story="Theme" mdxType="ArgsTable" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const theme = highlightDemo.bind({});
theme.storyName = 'Theme';
theme.args = {
  language: 'html'
};
theme.parameters = { storySource: { source: 'highlightDemo.bind({})' } };

const componentMeta = { title: 'Vendor/Highlight', parameters: {
  docs: {
    transformSource: src => src
  },
  layout: 'fullscreen'
}, argTypes: {
  language: {
    options: availableSamples,
    type: 'string',
    control: {
      type: 'select'
    }
  }
}, includeStories: ["theme"],  };

const mdxStoryNameToKey = {"Theme":"theme"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;